import { useMemo } from 'react'
import { buildOrderUrl } from '~/utils/urls'

/**
 * カートページのURLを返す、だけ
 */
export function useCartPageUrl(): URL {
  return useMemo(() => {
    const url = buildOrderUrl('cart/items/')

    return url
  }, [])
}
